<script setup lang="ts">

</script>

<template>
  <nav-pill class="nav-pill">
    <sidebar-self-avatar />
  </nav-pill>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.nav-pill
  @apply px-1
</style>
